import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConceptLifecycleStatus } from "@/hooks/useConceptLifecycleStatus";

// Globally mounted once in App.js — the same pattern as BusinessQualityLayer/
// BusinessReviewHub, so none of the 69 concept-site files need to know this exists.
//
// Reads each site's lifecycle status (via the shared useConceptLifecycleStatus hook,
// also used by BusinessSeo for robots noindex) and, only for status === "online_client",
// hides the concept disclaimer bar and the "Why this matters" sales pill. Every other
// status (including a fetch failure, which the hook resolves to null) leaves the page
// exactly as it already renders — the concept disclaimer is the safe default, never
// suppressed by accident.
//
// The disclaimer bar itself has a different data-testid and wrapper element in every
// vertical (law-disclaimer, dental-disclaimer, ev-disclaimer as an <aside>, etc.), so
// rather than hardcoding 69 selectors this locks onto the one thing every version of
// it has in common: the "MySiteCare" link inside it pointing at mysitecare.eu/ph.
export default function ConceptLifecycleGate() {
  const { pathname } = useLocation();
  const { status } = useConceptLifecycleStatus(pathname);

  useEffect(() => {
    if (status === "online_client") applyOnlineClientMode();
  }, [status, pathname]);

  return null;
}

function applyOnlineClientMode() {
  const mysitecareLink = document.querySelector('a[href="https://mysitecare.eu/ph"]');
  if (mysitecareLink) {
    const disclaimer = mysitecareLink.closest("div, aside, section");
    if (disclaimer && /concept website created by/i.test(disclaimer.textContent || "")) {
      disclaimer.style.display = "none";
    }
  }
  const actions = document.querySelector('[data-testid="concept-cta-actions"]');
  if (actions) actions.style.display = "none";
}
